export interface ICrudColumn {
  field: string;
  header: string;
  icon?: string; // pass icon class optional for header
  type?: string; // decimal, number, currency, Charges, image, Date, Products, object, icons
  sortable?: string; // pass the field value you wish to sort by
  converter?: any; // a custom function to transform the value anyway you want.
  style?: string;
  append?: string;
}

/*
 ## COLUMN CONVERTER EXAMPLE ##
   converter: (val) => {
     if (val?.length) return val[0]?.name;
     return 'None';
   }

  Usage in the crud component itself:
  col.converter(rowData[col.field])
 */

export interface ICrudAction {
  icon?: string;
  label: string;
  handleAction: string;
  class?: string;
  position?: string; // positions the button on the actions table (right sends it to the right)
}
